import React from 'react';
import { SecretOptionsWrap } from '../styles/EditSecretsOptions';

export const AddChestOptions = () => {
  return <SecretOptionsWrap></SecretOptionsWrap>;
};
